import React from "react";
import "../../style/Body/Final.css";
import success from "../../assets/success.png";
import fail from "../../assets/fail.png";
import Button from "react-bootstrap/Button";
import { useAppContext } from "../../AppContext";

export default function Final() {
  const { globalState, setGlobalState } = useAppContext({});

  const handelRetry =(retry) =>{
    if(retry){

      setGlobalState({
        ...globalState,
        step: "4",
      });
    } else {

      setGlobalState({
        ...globalState,
        step: "6",
      });
    }
  }
  return (
    <>
    {globalState.succesFinal ?
      <div className="center-box-final">
        <img src={success} alt="Imagen" className="center-box-image-final" />
        <p className="center-box-text-final">¡Felicitaciones!</p>
        {globalState.whatsapp ? ( <p className="center-box-text-final small">
          Tu recarga ha sido realizada
        </p>) : ( <p className="center-box-text-final small">
          Tus respuestas fueron guardadas con exito
        </p>)}
       
        <Button
            variant="outline-primary"
            className="btn-icon-final"
            onClick={()=>handelRetry(false)}
          >
            <span className="button-text-final">Compartir</span>
          </Button>
      </div>
      :
      <div className="center-box-final">
        <img src={fail} alt="Imagen" className="center-box-image-final" />
        <p className="center-box-text-final">¡Se ha producido un error!</p>
        <p className="center-box-text-final small">
          No hemos podido realizar tu recarga, por favor vuelve a intentar
        </p>

        <div class="row ">
        <div class="col center">
        <Button
            variant="outline-primary"
            className="btn-icon-final compartir p-3 pl-4 pr-4"
            onClick={()=>handelRetry(true)}
          >
            <span className="button-text-final">Reintentar</span>
          </Button>
        </div>
        <div class="col center">
        <Button
            variant="outline-primary"
            className="btn-icon-final compartir p-3 pl-4 pr-4"
            onClick={()=>handelRetry(false)}
          >
            <span className="button-text-final">Compartir</span>
          </Button>
        </div>

        </div>


      </div>
    }
    </>
  );
}
